import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ConsultaComponente from "../../components/utils/ConsultaComponente";

export default function Consultas() {
  return (
     <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Consultas" />

        {/* RoleAccessLayer */}
        <ConsultaComponente/>

      </MasterLayout>

    </>
  )
}
